var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "windows",
    fill: "#1976D2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 7.55555556 0 7.55555556 7.55555556 0 7.55555556"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.46311111 7.53688889 8.46311111 0 16 0 16 7.53688889"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 8.44444444 7.55555556 8.44444444 7.55555556 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.44444444 16 8.44444444 8.44444444 16 8.44444444 16 16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsWindows);
export default __webpack_public_path__ + "static/media/os_windows.be38f5075ab90fa19af0ec9c451ebf5b.svg";
export { ForwardRef as ReactComponent };